import type { ComponentType } from "react";
import type { Extension } from "@/types/entities";
import { EscaladeDentalBookingsExtension } from "@/extensions/escalade-dental/bookings/extension";
import { BusinessNumberConsultingInsightsExtension } from "@/extensions/business-number-consulting/insights/extension";

export type ExtensionComponentProps = {
  tenantSlug: string;
  extension: Extension;
};

function normalizeMapKey(tenantSlug: string, extensionName: string) {
  return `${tenantSlug.trim().toLowerCase()}::${extensionName.trim().toLowerCase()}`;
}

const extensionComponentMap = new Map<string, ComponentType<ExtensionComponentProps>>([
  [normalizeMapKey("escalade-dental", "booking-extension-cms"), EscaladeDentalBookingsExtension],
  [normalizeMapKey("business-number-consulting", "broadcast-insights-cms"), BusinessNumberConsultingInsightsExtension],
]);

export const resolveExtensionComponent = (tenantSlug: string, extensionName: string) => {
  return extensionComponentMap.get(normalizeMapKey(tenantSlug, extensionName));
};

export const hasMappedExtension = (tenantSlug: string, extensionName: string) => {
  return extensionComponentMap.has(normalizeMapKey(tenantSlug, extensionName));
};
